// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3y_hK","container":"styles_container__1yrJV","title":"styles_title__2c5al","wrapper":"styles_wrapper__1MTdM","answer":"styles_answer__3iHcX"};